export default __webpack_public_path__ + "static/media/low-fees-icon.9866148d.svg";